import { getI18n } from 'react-i18next';
import { call, fork, put, take } from 'redux-saga/effects';
import { onEnqueueErrorSnackbar } from './enqueueSnackbarFlow';
import {Api} from '../api';
import {AssetGroup} from '../api/types';
import Logger from '../common/logger';
import {fetchAllAssetGroups} from '../action/locationsCommands';
import {allAssetGroupsFetched} from '../action/locationsEvents';

export const onFetchAssetGroups = function* () {
    try {
        const assetGroups: AssetGroup[] = yield call(Api.fetchAllLocationAssetGroups);
        yield put(allAssetGroupsFetched({ assetGroups }));
    } catch (error) {
        Logger('Saga').error(error);
        yield fork(onEnqueueErrorSnackbar, getI18n().t('assetGroups.error.fetch_assetGroups'));
    }
};


export function* fetchAssetGroupsFlow() {
    while (true) {
        yield take(fetchAllAssetGroups.toString());
        yield fork(onFetchAssetGroups);
    }
}
